import { encryptSmsDestination, decryptSmsDestination, userPublicKeyFromPrivate } from './smsDestination';
import { loadVaultSession } from './vaultSession';

export function createSmsDeliveryReference(): string {
  return crypto.randomUUID().replaceAll('-', '');
}

export async function buildSmsDestinationCiphertext(
  phoneE164: string,
  reference: string,
): Promise<string> {
  const session = loadVaultSession();
  if (!session) {
    throw new Error('vault_locked');
  }

  const userPublicKey = userPublicKeyFromPrivate(session.userPrivateKey);
  return encryptSmsDestination(phoneE164, userPublicKey, reference);
}

export async function revealSmsDestination(
  destinationCiphertextBase64: string,
  reference: string,
): Promise<string | null> {
  const session = loadVaultSession();
  if (!session) {
    return null;
  }

  try {
    return await decryptSmsDestination(
      destinationCiphertextBase64,
      session.userPrivateKey,
      reference,
    );
  } catch {
    return null;
  }
}
